import React from 'react';

import PromoCountryItemWithCode from './PromoCountryItemWithCode';
import PromoCountryLetterItem from './PromoCountryLetterItem';

const PromoFullCountryList = (props) => {
    const getFirstLetter = (name) => {
        return name ? name.charAt(0) : null;
    };

    if (Array.isArray(props.countries) && props.countries.length > 0) {
        let firstLetter = '';
        return (
            <>
                {props.countries.map((country) => {
                    if (firstLetter === getFirstLetter(country.name)) {
                        return (
                            <PromoCountryItemWithCode
                                key={`countryList_${country.code_a2}`}
                                country={country}
                                iso2={props.iso2}
                                onCountryItemClick={props.onCountryItemClick}
                                query={props.query}
                            />
                        );
                    } else {
                        firstLetter = getFirstLetter(country.name);
                        return (
                            <React.Fragment key={`countryList_${country.code_a2}`}>
                                <PromoCountryLetterItem letter={firstLetter} />
                                <PromoCountryItemWithCode
                                    country={country}
                                    iso2={props.iso2}
                                    onCountryItemClick={props.onCountryItemClick}
                                    query={props.query}
                                />
                            </React.Fragment>
                        );
                    }
                })}
            </>
        );
    } else {
        return false;
    }
};

export default PromoFullCountryList;
